// Generated by CoffeeScript 1.12.7

/**
Generates a Cloudinary image path with unique sizing string in url.
NOTE: This is not included in the utilities module since cloudinary.js is required

@method transformImage
@param {String} image the image url or cloudinary id
@param {Object} options transformation options (https://cloudinary.com/documentation/image_transformations)
@param {Boolean} html whether to return an html image tag or plain image url
@return {Object}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/transform_image',['cloudinary'], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory(require('cloudinary'));
  } else {
    return root.transformImage = factory(root.cloudinary);
  }
})(this, function(cloudinary) {
  var transformImage;
  return transformImage = function(image, options, html) {
    var transfromer;
    if (html == null) {
      html = false;
    }
    transfromer = cloudinary.Cloudinary["new"]({
      cloud_name: "surveyplanet"
    });
    if (/^(http(s?):).+/.test(image)) {
      image = image.split('/').pop();
    }
    if (html) {
      return transfromer.imageTag(image, options).toHtml();
    } else {
      return transfromer.url(image, options);
    }
  };
});

